import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

export const ICON_DEFINITIONS = {
  check: faCircleCheck,
};
